import { DialogRef } from '@angular/cdk/dialog';
import { Directive, inject } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';

@Directive({
  selector: '[appCloseApplicationModal]',
  host: {
    '(click)': 'closeModal()',
  },
})
export class CloseApplicationModalDirective {
  private readonly _dialogRef = inject(DialogRef);
  private readonly _fgd = inject(FormGroupDirective);

  protected closeModal() {
    this._dialogRef.close();
    this._fgd.form.reset();
    this._fgd.form.enable();
  }
}
